module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_15_1.c02b80a1.jpeg";